import apiService from "./apiService";

const judgeService = {
    async search(searchParams) {
        try {
            return (await apiService.get(`judge/search`, searchParams, true)).data;
        }
        catch {
            return [];
        }
    },
    async getInfo(id) {
        try {
            return (await apiService.get(`judge/get-info/${id}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async saveJudge(judge) {
        try {
            return (await apiService.post(`judge/save/`, judge, true)).data;
        }
        catch {
            return [];
        }
    },
    async deleteJudge(id) {
        try {
            return (await apiService.post(`judge/delete/${id}`, {}, true)).data;
        }
        catch {
            return {success:false, message: "An error occured while processing the request."};
        }
    },
}

export default  judgeService;